import {useState } from 'react';
import { useNavigate } from 'react-router-dom'; 
import Footer from '../../components/common/footer';
import Header from '../../components/common/header';

function Termos() {

  const handlePrint = () => {
    window.print();
  };

  const navigate = useNavigate();

  const [isInverted, setIsInverted] = useState(false);

  const toggleInvert = () => {
    setIsInverted(!isInverted);
  };

  const handleKeyPress = (event, action) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      action();
    }
  };

  return (
    <div 
      className={`flex flex-col min-h-screen fundo-morro ${isInverted ? 'inverted' : ''}`}
      role="application"
      aria-label="Termos de Uso - EstimaGas"
    >
      <Header isInverted={isInverted} toggleInvert={toggleInvert} size={14}/>      
      <main 
        className="p-4 my-4 mx-auto w-1/2 border border-cinza shadow-inner bg-branco"
        role="main"
      >
        <div className="mb-4">
          <button 
            className="bg-gray-200 px-3 py-1 mr-2 rounded" 
            onClick={() => navigate('/')}
            aria-label="Voltar para a página inicial"
          >
            ← Voltar
          </button>
          <button 
            className="bg-gray-200 px-3 py-1 rounded" 
            onClick={handlePrint}
            aria-label="Imprimir termos de uso"
          >
            Imprimir
          </button>
        </div>
      
        <h1 className="text-3xl font-bold mb-6">Termos de uso</h1>

        <section aria-labelledby="navegador-title">
          <h2 id="navegador-title" className="text-2xl font-semibold mb-4">Navegador recomendado</h2>
          <p className="mb-4">
            É altamente recomendável utilizar um navegador atualizado que suporte as tecnologias modernas da web. São indicados os navegadores:
          </p>

          <ul className="list-disc list-inside mb-6" role="list">
            <li>Google Chrome 80 ou superior</li>
            <li>Mozilla Firefox 75 ou superior</li>
            <li>Microsoft Edge 80 ou superior</li>
            <li>Apple Safari 13 ou superior</li>
            <li>Opera 67 ou superior</li>
          </ul>

          <p className="mb-6">
            Para garantir a ótima visualização e desempenho, mantenha sempre seu navegador atualizado.
          </p>
        </section>

        <section aria-labelledby="javascript-title">
          <h2 id="javascript-title" className="text-2xl font-semibold mb-4">JavaScript e Folhas de Estilo (CSS)</h2>
          <p className="mb-4">
            Nossa aplicação utiliza tecnologias que dependem do suporte a JavaScript e CSS. Para uma experiência adequada, é essencial que:
          </p>

          <ul className="list-disc list-inside mb-6" role="list">
            <li>O JavaScript esteja habilitado em seu navegador.</li>
            <li>O suporte a folhas de estilo (CSS) esteja ativado, garantindo que a interface e o design sejam exibidos corretamente.</li>
          </ul>

          <p className="mb-6">
            Caso essas funcionalidades estejam desabilitadas, algumas partes do site podem não funcionar corretamente.
          </p>
        </section>
      </main>
      <Footer/>
    </div>
  );
}

export default Termos;
